<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
    <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="2">
      <line x1="1.307" x2="21.813" y1=".939" y2="21.445" />
      <line x1="21.459" x2=".953" y1="1.707" y2="22.213" />
    </g>
  </svg>
</template>
